var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-236 -826)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(239 839)",
    fill: "#4f5b6d",
    fontSize: 16,
    fontFamily: "SofiaProSoftBold, Sofia Pro Soft"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "%")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.23a9c9111d27948a96b760c8f37505dd.svg";
export { ForwardRef as ReactComponent };